import { Warehouse } from '../../interfaces/Warehouse'
import { WarehouseAction } from '../actions/warehouseActions'
import { GET_WAREHOUSES_EXITO } from '../types/warehouseActionsTypes'

export interface WarehouseState {
  warehousesState: {
    warehouses?: Warehouse[]
    error?: string | undefined
  }
}

const initialState: WarehouseState = {
  warehousesState: { warehouses: [], error: '' }
}

export const warehouseReducer = (
  state: WarehouseState = initialState,
  action: WarehouseAction
): WarehouseState => {
  if (action.type === GET_WAREHOUSES_EXITO) {
    return {
      ...state,
      warehousesState: {
        warehouses: action.warehouses,
        error: action.error
      }
    }
  }
  return state
}
